import { render, staticRenderFns } from "./list-form-right.vue?vue&type=template&id=3cd6ab6e"
import script from "./list-form-right.vue?vue&type=script&lang=js"
export * from "./list-form-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports